module.exports = __webpack_public_path__ + "static/media/redarrow.b459e247.svg";